module.exports = __webpack_public_path__ + "img/pipe.542e7e6f.png";